import { Action } from "redux"
import { IPendingNotifications } from "./index"

export const INITIALIZE = "PENDINGNOTIFICATIONS_INITIALIZE"
export const SET_UNREAD_NOTIFICATIONS_COUNT =
    "PENDINGNOTIFICATIONS_SET_UNREAD_NOTIFICATIONS_COUNT"
export const INCREASE_UNREAD_NOTIFICATIONS_COUNT =
    "PENDINGNOTIFICATIONS_INCREASE_UNREAD_NOTIFICATIONS_COUNT"

export interface Initialize extends Action {
    unreadNotificationsCounter: number
}

export const initialize = (props: IPendingNotifications): Initialize => ({
    type: INITIALIZE,
    ...props,
})

export interface SetUnreadNotificationsCounter extends Action {
    unreadNotificationsCounter: number
}

export const setUnreadNotificationsCounter = (
    unreadNotificationsCounter: number,
): SetUnreadNotificationsCounter => ({
    type: SET_UNREAD_NOTIFICATIONS_COUNT,
    unreadNotificationsCounter,
})

export interface IncreaseUnreadNotificationsCounter extends Action {
    count: number
}

export const increaseUnreadNotificationsCounter = (
    count: number,
): IncreaseUnreadNotificationsCounter => ({
    type: INCREASE_UNREAD_NOTIFICATIONS_COUNT,
    count,
})

export const mapDispatchToProps = {
    initialize,
    setUnreadNotificationsCounter,
    increaseUnreadNotificationsCounter,
}

export type DispatchProps = typeof mapDispatchToProps
